<mat-dialog-content>
  <div matCardSubtitle *ngIf="titleModale">
    {{titleModale}}
  </div>
  <div class="form-group">
    <div fxFlex="calc(90% - 25px)" style="margin-bottom: 20px">
      <mat-label style="font-size: larger;">Type du formulaire:</mat-label>
      <mat-radio-group [(ngModel)]="item.type" [disabled]="item.state !== formState.draft">
        <mat-radio-button *ngFor="let t of getEnumTypeForm()" [value]="t" style="margin-left: 15px" [attr.data-cy]="'option-form-modal-' + t.id">
          {{formType[t]}}
        </mat-radio-button>
      </mat-radio-group>
    </div>
  </div>

  <div class="form-group">
    <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
      <mat-label>Catégories</mat-label>

      <mat-select
        [(ngModel)]="item.categories"
        multiple
        data-cy="select-form-modal-categories">

        <mat-option *ngFor="let cat of categoriesList"
                    [value]="cat.id"
                    [disabled]="!cat.active">
          {{ cat.name }}
        </mat-option>

      </mat-select>

      <!-- ➕ Add Category Button -->
      <button
        mat-icon-button
        matSuffix
        type="button"
        (click)="onAddCategorie($event)"
        matTooltip="Ajouter une catégorie">
        <mat-icon>add</mat-icon>
      </button>

      <mat-hint *ngIf="!categoriesList?.length">
        Aucune catégorie disponible
      </mat-hint>
    </mat-form-field>
  </div>
  <mat-tab-group animationDuration="0ms" mat-stretch-tabs="false" mat-align-tabs="start">
    <mat-tab label="Paramétres">

      <div class="mandatory-right">
        <mat-hint class="required-hint">* champs obligatoires</mat-hint>
      </div>
      <div class="form-group g-flex">
        <mat-checkbox labelPosition="after" [(ngModel)]="item.is_accepted_like_admissible" data-cy="chkbx-is-accepted-like-admissible">
          Transformer le libellé du statut "Acceptée" en "Recevable"
        </mat-checkbox>
        <span class="icon-help-wrapper">
          <i class="fa fa-question-circle-o" aria-hidden="true" matTooltip="le statut que verra le demandeur sera libellé à Recevable"></i>
        </span>
      </div>
      <div class="form-group g-flex" style="padding-bottom: 15px">
        <mat-checkbox labelPosition="after" [(ngModel)]="item.visibility_avis" data-cy="chkbx-visibility_avis">
          Autoriser la visibilité des avis pour tous les sollicités
        </mat-checkbox>
        <span class="icon-help-wrapper">
          <i class="fa fa-question-circle-o" aria-hidden="true" matTooltip="
                  selon le paramétrage du formulaire : visibilité des avis entre sollicités [_]
                  si ce paramétrage permet cette visibilité entre sollicité, chaque sollicité peut avoir la liste des avis sur une demande, ainsi que leur historique
        "></i>
        </span>
      </div>
      <div class="form-group">
        <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
          <mat-label>Titre</mat-label>
          <input
            required
            matInput
            maxlength="{{titreMaxLen}}"
            [(ngModel)]="item.nom"
          />
          <mat-hint align="end"><code>{{item.nom?.length}}</code> / <code>{{titreMaxLen}}</code></mat-hint>
        </mat-form-field>
      </div>
      <div class="form-group" *ngIf="item.type === formType.Sondage">
        <mat-form-field color="accent" appearance="outline" fxFlex="calc(45% - 15px)">
          <mat-label>Date de début du sondage</mat-label>
          <input matInput [matDatepicker]="picker1"
                 [(ngModel)]="item.date_debut"
                 placeholder="sélectionner une date de début"
                 matTooltip="Sélectionner une date de début">
          <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>

        <mat-form-field color="accent" appearance="outline" fxFlex="calc(45% - 15px)" style="margin-left: 25px">
          <mat-label>Date de fin du sondage</mat-label>
          <input matInput [matDatepicker]="picker2"
                 [(ngModel)]="item.date_fin"
                 placeholder="sélectionner une date de fin"
                 matTooltip="Sélectionner une date de fin"
                 [min]="minDate"
                 [required]="item.type === formType.Sondage">
          <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2 color="primary"></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="form-group">
        <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
          <mat-label>Description</mat-label>
          <input
            matInput
            maxlength="{{descriptionMaxLen}}"
            [(ngModel)]="item.description"
          />
          <mat-hint align="end"><code>{{item.description?.length}}</code> / <code>{{descriptionMaxLen}}</code></mat-hint>
        </mat-form-field>
      </div>
      <div>
        <mat-divider></mat-divider>
      </div>
      <div class="form-group">
        <app-dm-email-generic #emailGeneric
                              [form]="item"
                              (emailEvent)="onEmailSend($event)"></app-dm-email-generic>
      </div>

      <div class="form-group">
        <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
          <mat-label>Signature pour les notifications par courriel vers les demandeurs</mat-label>
          <textarea
            rows="3"
            required
            matInput
            matTooltip="le texte de la signature qui sera apposée en fin du courriel lors d'une notification vers le demandeur"
            placeholder="le texte de la signature qui sera apposée en fin du courriel lors d'une notification vers le demandeur"
            [maxlength]="signatureMaxLen"
            [(ngModel)]="item.signature_email"
            data-cy="txtarea-form-modal-txt-signature"
          ></textarea>
          <mat-hint align="end"><code>{{item.signature_email?.length}}</code> / <code>{{signatureMaxLen}}</code></mat-hint>
        </mat-form-field>
      </div>


    </mat-tab>
    <mat-tab label="Ajouter des fichiers">
      <div style="min-height: 350px; padding-top: 15px">
        <div class="form-group">
          <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
            <mat-label>Titre pour block documents</mat-label>
            <input
              matInput
              [maxlength]="titreMaxLen"
              [(ngModel)]="item.titre_documents"
            />
            <mat-hint align="end"><code>{{item.titre_documents?.length}}</code> / <code>{{titreMaxLen}}</code></mat-hint>
          </mat-form-field>
        </div>
        <div class="attachements">
          <mat-hint class="title__info">(*) Pour selectionner plusieurs documents presser la touche Ctrl puis cliquer sur les documents à sélectionner.</mat-hint>
          <mat-list>
            <div mat-subheader fxLayoutAlign="end center" style="margin-bottom: 20px;">
              <button (click)="fileInput.click()" mat-raised-button data-cy="button-form-modal-browse">
                <mat-icon>attach_file</mat-icon>
                <span>parcourir </span>
                <input #fileInput
                       (change)="uploadFile($event)"
                       [accept]="allowedExtensions"
                       [multiple]="allowMultiple"
                       hidden
                       type="file"
                />
              </button>
            </div>
            <ng-container *ngIf="filesToUpload && filesToUpload.length > 0">
              <ng-container *ngFor="let file of filesToUpload; index as fIdx">

                <neo-message [canHide]="false" [messageType]="messageType.neutral"
                             [message]="file?.name"
                             [messageActions]="getActions(file, fIdx)"
                             (actionEvent)="checkAction($event)"></neo-message>
              </ng-container>
            </ng-container>
          </mat-list>
        </div>
      </div>

    </mat-tab>
  </mat-tab-group>


</mat-dialog-content>
<mat-dialog-actions fxLayoutAlign="center center">
<!--
  NG0100: ExpressionChangedAfterItHasBeenCheckedError: Expression has changed after it was checked. Previous value: 'false'. Current value: 'true'
  Erreur apparait seulement en dev, c'est le champ disabled qui semble poser pb
-->
  <button mat-raised-button color="accent" (click)="onCloseClick(true)" tabindex="1"
          [disabled]="isBlockedForNameSignatureEmailGeneric() || isBlockedForDateFin()" data-cy="button-form-modal-confirm">{{confirmButtonText}}</button>
  <button mat-raised-button *ngIf="cancelButtonText" color="warn" (click)="onCloseClick(false)" tabindex="1" data-cy="button-form-modal-cancel">{{cancelButtonText}}</button>
</mat-dialog-actions>
